module.exports = __webpack_public_path__ + "img/working-1.a773c34d.png";